import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { Sorter } from 'src/app/utils/sort-util';
import { EtatTache, Tache } from '../../models/taches/gestion-taches.model';
const minDate = new Date(-8640000000000000);
const minHour = "00:00";
export interface TachesState {
  jour: Tache[];
  toutes: Tache[];
}

@Injectable({ providedIn: 'root' })
export class TachesStoreService {
  private state: TachesState = { jour: [], toutes: [] };
  private subject = new BehaviorSubject<TachesState>(this.state);
  public state$ = this.subject.asObservable();

  public tachesJour$ = this.state$.pipe(
    map(state => state.jour),
    distinctUntilChanged()
  );

  public toutesTaches$ = this.state$.pipe(
    map(state => state.toutes),
    distinctUntilChanged()
  );

  private computeJourFromToutes(toutes: Tache[]): Tache[] {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return (toutes ?? []).filter(t =>
        t?.id &&
        (t.etat === EtatTache.AFaire || t.etat === EtatTache.EnCours) &&
        t.date &&
        new Date(t.date) <= today
    );
}


  private emitState(newToutes: Tache[]) {
    const toutesValid = (newToutes ?? []).filter((t): t is Tache => !!t?.id);
    const jour = this.computeJourFromToutes(toutesValid);
    this.state = { toutes: toutesValid, jour };
    this.subject.next(this.state);
  }

  public addOrUpdateTaches(taches: Tache[]) {
    const toutes = [...this.state.toutes];
    taches.forEach(newTache => {
      const index = toutes.findIndex(t => t.id === newTache.id);
      if (index >= 0) {
        toutes[index] = { ...toutes[index], ...newTache };
      } else {
        toutes.push(newTache);
      }
    });
    const tachesTriees = this.triTaches(toutes);

    this.emitState(tachesTriees);
  }

  public updateTache(updated: Tache) {
    this.addOrUpdateTaches([updated]);
  }

  public deleteTache(id: number) {
    const toutes = this.state.toutes.filter(t => t.id !== id);
    const tachesTriees = this.triTaches(toutes);
    this.emitState(tachesTriees);
  }

  private triTaches(taches: Tache[]): Tache[] {
    return new Sorter<Tache>()
      .orderBy(
        trierPar => trierPar.date(tache => tache.date ?? minDate),
        puisPar => puisPar.string(tache => tache.heureDebut ?? minHour),
        puisPar => puisPar.string(tache => tache.heureFin ?? minHour),
        puisPar => puisPar.string(tache => tache.titre ?? ''))
      .execute(taches)
  }
}
